"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contains = void 0;
const assertString_1 = require("./util/assertString");
const toString_1 = require("./util/toString");
const merge_1 = require("./util/merge");
const defaulContainsOptions = {
    ignoreCase: false,
};
function contains(str, elem, options = {}) {
    (0, assertString_1.assertString)(str);
    options = (0, merge_1.merge)(options, defaulContainsOptions);
    return options.ignoreCase ?
        str.toLowerCase().indexOf((0, toString_1.toString)(elem).toLowerCase()) >= 0 :
        str.indexOf((0, toString_1.toString)(elem)) >= 0;
}
exports.contains = contains;
